<template>

  <a-row :gutter="20">
    <a-col :span="6" >
      <div class="voice-panel left">
        <a v-for="(item,index) in data" class="item" :key="index" @click="itemClick(index)">
          {{item.url || 'xxx.mp3'}}
        </a>
      </div>
    </a-col>
    <a-col :span="18">
      <div class="voice-panel left">
        {{current.content}}
      </div>
    </a-col>
  </a-row>
</template>

<script>
  export default {
    name: 'Item2',
    components: {  },
    props:{
      data:{
        type:Array,
        default:()=>{
          return []
        }
      }
    },
    data(){
      return {
        currentIndex:0,
      }
    },
    computed:{
      current(){
        if(this.data.length>0 && this.data.length-1 >= this.currentIndex){
          return this.data[this.currentIndex]
        }else{
          return {}
        }
      },
    },
    mounted(){

    },
    methods:{
      itemClick(index){
        this.currentIndex = index
      }
    }
  }
</script>

<style scoped lang="less">
  .voice-panel{
    padding: 10px
  }
  .left{
    min-height: 330px;
  }
  .item{
    margin-top: 10px;
  }
</style>